import form from './form';

const wizard = { form };

export default wizard;
